"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTypeEnum = void 0;
var UserTypeEnum;
(function (UserTypeEnum) {
    UserTypeEnum["Credentials"] = "credentials";
    UserTypeEnum["Google"] = "google";
    UserTypeEnum["Apple"] = "apple";
    UserTypeEnum["Twitter"] = "twitter";
    UserTypeEnum["MagicLink"] = "magicLink";
})(UserTypeEnum = exports.UserTypeEnum || (exports.UserTypeEnum = {}));
//# sourceMappingURL=user-type-enum.js.map